module.exports = __webpack_public_path__ + "static/how_it_works_life_art@2x-b29334ba719f6cc43283286e8210e695.png";